"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubModelSignalMapItemBaseSchema = void 0;
const zod_1 = require("zod");
const SignalId_1 = require("./DesignModels/SignalId");
exports.ISubModelSignalMapItemBaseSchema = zod_1.z.object({
    componentSignalId: SignalId_1.SignalIdSchema.optional(),
    comment: zod_1.z.string().optional(),
});
//# sourceMappingURL=ISubModelSignalMapItemBase.js.map